import { render, staticRenderFns } from "./institutionDetail.vue?vue&type=template&id=0bb6ea72&scoped=true"
import script from "./institutionDetail.vue?vue&type=script&lang=js"
export * from "./institutionDetail.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/articleDetail.css?vue&type=style&index=0&id=0bb6ea72&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb6ea72",
  null
  
)

export default component.exports